module.exports = __webpack_public_path__ + "img/bergen-480.3650353c.png";